var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.shownProperties && _vm.shownProperties.length
    ? _c("div", { staticClass: "card px-4 border-0" }, [
        _c(
          "ul",
          {
            staticClass:
              "order-property-list list-unstyled row d-flex justify-content-between p-3 mb-0",
            attrs: { "data-testing": "order-property-list" },
          },
          [
            _vm.dateComp
              ? _c("li", [
                  _c("span", { staticClass: "d-block" }, [
                    _c("strong", [_vm._v(" Geburtstag : ")]),
                    _vm._v(" "),
                    _c("span", [
                      _c("span", [_vm._v(" " + _vm._s(_vm.dateComp) + " ")]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.shownProperties, function (property) {
              return _c("order-property-value-list-item", {
                key: property.propertyId,
                attrs: { property: property },
              })
            }),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }